import { Heading } from "components/designV2/heading/heading";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";
import { FormStyled } from "../registration/registrationContainer/registrationContainer.styled";

export const StyledForm = styled(FormStyled)`
  max-width: 420px;
  gap: 16px;
  padding: 0 10px;
`;

export const StyledTitle = styled(Heading).attrs({
  level: "h3",
})`
  margin-bottom: 8px;
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;

  button {
    margin-top: 0;
  }
`;

export const TermsSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 8px;
  width: 100%;
`;

export const TermsTextWrapper = styled.div`
  display: block;
  padding-top: 2px;
`;

export const TermsText = styled(Text).attrs({
  typography: "b1",
})`
  display: block;
  margin: 0;
  line-height: 1.35;
`;

export const TermsLink = styled.button`
  ${TypographyV2.b1}
  display: inline;
  background: transparent;
  border: none;
  padding: 0;
  color: ${ColorV2.Blue1};
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  text-align: inherit;
  letter-spacing: inherit;
  line-height: 1.35;
  cursor: pointer;
  vertical-align: baseline;
  appearance: none;
  -webkit-appearance: none;
  text-decoration: underline;

  &:focus {
    outline: none;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 8px;
  width: 100%;
`;
